import { Middleware } from 'redux';
import * as telemetry from '../../telemetry';
import { LOCATION_CHANGE, LocationChangeAction } from 'connected-react-router';
import { removeQueryString } from 'helpers/tools';
import upperFirst from 'lodash/upperFirst';

export const computePageNameFromPath = (path: string) => {
    const pathName = path.split('?')[0].substring(1);
    return upperFirst(pathName);
};
export const splitPathAndQueryString = (path: string): { path: string; queryString?: string; shouldSkip: boolean } => {
    if (path.startsWith('/access_token')) {
        return { path: '/', shouldSkip: true };
    }
    const queryStringStart = path.indexOf('?');
    return {
        path: queryStringStart < 0 ? path : path.slice(0, queryStringStart),
        queryString: queryStringStart < 0 ? undefined : path.slice(queryStringStart + 1),
        shouldSkip: false,
    };
};

const pagetrack: Middleware = () => next => action => {
    if (action.type === LOCATION_CHANGE) {
        const payload = (action as LocationChangeAction).payload;
        const { path, shouldSkip } = splitPathAndQueryString(payload.location.pathname);

        if (!shouldSkip) {
            telemetry.page(computePageNameFromPath(path), {
                path,
                name: computePageNameFromPath(path),
                referrer: removeQueryString(window.document.referrer),
            });
        }
    }
    return next(action);
};
export default pagetrack;
